import React from 'react';
import { riskMatrix } from './RiskOppMatrix';

const RiskMatrixTable = () => {
  // Create a 2D array to hold the score and level for the risk matrix
  const riskTable = Array(5).fill(null).map(() => Array(5).fill({ score: '-', level: '-' }));

  // Populate the riskTable with values from the riskMatrix
  riskMatrix.forEach(item => {
    const { impact, likelihood, score, level } = item;
    riskTable[likelihood - 1][impact - 1] = { score, level };
  });

  return (
    <div className="p-4 text-sm bg-white text-blue-800">
      <div className="mb-8">
        <h3 className="text-xl font-bold mb-4 text-purple-600">Risk Matrix</h3>
        <div className="overflow-x-auto">
          <p>Left To Right: Impact Category, Top To Bottom: Likelihood Category</p>
          <table className="min-w-full bg-white text-blue-800 border border-gray-300">
            <thead>
              <tr>
                <th className="px-2 py-2 border-b border-r text-white bg-blue-500"></th>
                {[1, 2, 3, 4, 5].map(i => (
                  <th key={i} className="px-2 py-2 border-b border-r text-white bg-blue-500 text-xs md:text-sm">{i}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map(likelihood => (
                <tr key={likelihood} className="text-blue-800">
                  <td className="px-2 py-2 border-b border-r text-blue-800 bg-gray-100">{likelihood}</td>
                  {[1, 2, 3, 4, 5].map(impact => {
                    const { score, level } = riskTable[likelihood - 1][impact - 1];
                    return (
                      <td key={impact} className="px-2 py-2 border-b border-r text-blue-800 text-xs md:text-sm">
                        <div>{score}</div>
                        <div>{level}</div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RiskMatrixTable;
